// extracted by mini-css-extract-plugin
module.exports = {"HomePage":"HomePage_HomePage__vp3iw","Hero":"HomePage_Hero__Az1df","SectionTitle":"HomePage_SectionTitle__KCf7Z typography_H2__EDc6d"};